<template>
    <div class="layui-fluid">
      <div class="layui-row layui-col-space15">
        <div class="layui-col-md12">
          <div class="layui-card">
            <div class="layui-card-header">修改密码: &nbsp;</div>
              <div class="layui-card-body">
                <div class="layui-form">
                  <div class="layui-form-item">
                    <label class="layui-form-label">当前密码: &nbsp;</label>
                    <div class="layui-input-inline">
                      <input type="password" name="oldPassword" autocomplete="off" class="layui-input" v-model="curPw">
                    </div>
                  </div>
                  <div class="layui-form-item">
                    <label class="layui-form-label">新密码: &nbsp;</label>
                    <div class="layui-input-inline">
                      <input type="password" name="password"  autocomplete="off" class="layui-input"  v-model="newPw">
                    </div>
                    <div class="layui-form-mid layui-word-aux">6到16个字符</div>
                  </div>
                  <div class="layui-form-item">
                    <label class="layui-form-label">确认新密码: &nbsp;</label>
                    <div class="layui-input-inline">
                      <input type="password" name="repassword" autocomplete="off" class="layui-input"  v-model="repeat">
                    </div>
                  </div>
                  <div class="layui-form-item">
                    <div class="layui-input-block">
                      <button class="layui-btn" @click="change()">确认修改</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
</template>
<script>
import request from '../../../network/networkconfig';
export default {
  name: 'UserChangePassword',
  data () {
    return {
        requestUniqueId: 'updatePw',
        curPw: null,
        newPw: null,
        repeat: null,
    }
  },
  mounted() {

  },
  methods: {
      change() {
           if(!this.curPw) {
                this.layer.openAlert('请输入当前密码！', false);
                return;
           }
           if(!this.newPw) {
                this.layer.openAlert('请输入新密码！', false);
                return;
           }
           if(!this.repeat) {
                this.layer.openAlert('请输入确认新密码！', false);
                return;
           }
           if(this.newPw != this.repeat) {
                this.layer.openAlert('新密码两次输入不一致！', false);
                return;
           }
           var base64= new Base64();
           var curPassword = base64.encode(unescape(encodeURIComponent(this.curPw)));
           var newPassword = base64.encode(unescape(encodeURIComponent(this.newPw)));
           var user = this.security.getUser();

            request({
                url: '/login/updatepw/' + user.getUid() + '/' + curPassword + '/' + newPassword,
                method: 'post',
            }).then((response)=> {
                if(response.errorMsg) {
                    this.layer.openAlert(response.errorMsg, false);
                } else {
                    if(response.result == true) {
                        this.layer.openSuccess('修改成功，请重新登录!');
                        setTimeout(() => {
                            this.security.logout();
                            this.$bus.$emit(this.dict.event.LOGOUT);
                        }, 2000);

                    } else {
                         this.layer.openAlert(response.result, false);
                    }
                }
            });
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ywpt/user/UserChangePassword.vue